import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';

interface Props {
  onSearch?: () => Promise<void>;
  onReset: () => void;
}

export function SearchAndResetButtonGroup({ onSearch, onReset }: Props) {
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button label={getButtonName('inquiry')} onClick={onSearch} />
      <Button label={getButtonName('reset')} onClick={onReset} />
    </ButtonGroup>
  );
}
